import { ContentPanel } from '@hopskipdrive/react-components';
import styled from 'styled-components';

export const RidesTableContainer = styled(ContentPanel)<{ $headingHeight?: number }>`
  &.MuiBox-root {
    margin-top: 8px;
  }
`;
